import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { services } from './ServicesDataSecureTeleworking';
import { TimelineFormation } from '../../ui/timeline-formation';
import './TimelineSecureTeleworking.css';

// Define necessary types locally based on usage
interface TimelineItemFeature {
  id: string;
  text: string;
  detailContent?: string;
}

interface TimelineItem {
  date: string;
  title: string;
  description: string;
  icon: string;
  features: TimelineItemFeature[];
}

const TimelineSecureTeleworking: React.FC = () => {
  const { t } = useTranslation();

  console.log('Services count:', services.length, services.map(s => s.title));

  // Get timeline data from translations
  const timelineData = t('secureTeleworking.timeline.services', { returnObjects: true });

  const timelineItems: TimelineItem[] = Array.isArray(timelineData)
    ? timelineData.map((timelineService: any, serviceIndex) => ({
        date: "",
        title: timelineService.title || services[serviceIndex]?.title || '',
        description: timelineService.description || services[serviceIndex]?.description || '',
        icon: services[serviceIndex]?.icon || '',
        features: (timelineService.features || [])
          .filter((featureText: string) => featureText !== '')
          .map((featureText: string, featureIndex: number) => ({
            id: `feature_${featureIndex}`,
            text: featureText,
            detailContent: undefined
          }))
      }))
    : services.map((service) => ({
        date: "",
        title: service.title,
        description: service.description,
        icon: service.icon,
        features: service.features
          .filter(f => f.text !== '')
          .map((feature, featureIndex) => ({
            id: `feature_${featureIndex}`,
            text: feature.text,
            detailContent: undefined
          }))
      }));

  useEffect(() => {
    const timelineCardTitles = document.querySelectorAll('.slider-cards h3.blue-h2-blue-bg');
    timelineCardTitles.forEach(element => {
      if (element instanceof HTMLElement) {
        element.style.paddingLeft = '30px';
      }
    });
  }, []);

  return (
    <div className="tw-container tw-mx-auto tw-px-4 tw-pb-16 tw-bg-transparent">
      <TimelineFormation items={timelineItems} showModule={true} moduleText="Phase" />
    </div>
  );
};

export default TimelineSecureTeleworking;
